import {
  Paper,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { MdSearch } from "react-icons/md";

export default function BillingTransactionsFilters({
  searchQuery,
  filterStatus,
  filterPaymentMethod,
  onSearchChange,
  onStatusChange,
  onPaymentMethodChange,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        borderRadius: "16px",
        border: "1px solid #E2E8F0",
      }}
    >
      <Box className="flex flex-col md:flex-row gap-3">
        <TextField
          placeholder="Search by name..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          size="small"
          sx={{ flex: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MdSearch className="text-slate-400" />
              </InputAdornment>
            ),
          }}
        />
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={filterStatus}
            label="Status"
            onChange={(e) => onStatusChange(e.target.value)}
          >
            <MenuItem value="all">All Status</MenuItem>
            <MenuItem value="Success">Success</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Failed">Failed</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Payment Method</InputLabel>
          <Select
            value={filterPaymentMethod}
            label="Payment Method"
            onChange={(e) => onPaymentMethodChange(e.target.value)}
          >
            <MenuItem value="all">All Methods</MenuItem>
            <MenuItem value="Card">Card</MenuItem>
            <MenuItem value="BankTransfer">Bank Transfer</MenuItem>
            <MenuItem value="Bank">Bank</MenuItem>
            <MenuItem value="Wallet">Wallet</MenuItem>
            <MenuItem value="Cash">Cash</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
}
